import { useMutation } from "@apollo/client";
import { UPDATE_COMPANY_BASIC_SETTINGS } from "../../graphql/mutations/CompanyAdminContext";

// eslint-disable-next-line import/prefer-default-export
export const useUpdateCompanyBasicSettings = () => {
  const [updateSettings, { error, loading }] = useMutation(UPDATE_COMPANY_BASIC_SETTINGS);

  const executeUpdateSettings = async ({ settings, onError, onSuccess }) => {
    try {
      const res = await updateSettings({
        variables: {
          settings,
        },
      });

      const basicSettings = res?.data?.companyAdminContext?.settings?.updateCompanyBasicSettings;

      if (!!basicSettings) {
        onSuccess?.(basicSettings);
      }
      else {
        onError?.();
      }
    } catch (err) {
      console.error("error >", err);
      onError?.();
    }
  };

  return [executeUpdateSettings, { error, loading }];
};
